const Spinner = () =>
{
    return (
        <div className="alert alert-secondary w-100" role="alert">
            <div className="d-flex justify-content-center">
                <div className="spinner-border text-primary m-2" role="status"></div>
            </div>
            <span className="d-flex justify-content-center fw-medium">{'Cargando... Por favor espere.'}</span>
        </div>
    );
}

export default Spinner;
